import { useContext } from "react";
import { Badge, Image, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { blastRoutes } from "../../constants";
import { RouteContext } from "../../contexts/routeContext";
import { SiteContext } from "../../contexts/siteContext";
import { UserDataContext } from "../../contexts/userDataContext";

const ToggleWrapper = ({ children, navItemClassName, setShow }) => (
	<Nav.Item
		className={`${navItemClassName} ${
			setShow ? "d-block d-md-none" : "d-none d-md-block"
		}`}
		onClick={setShow ? () => setShow(false) : null}
	>
		{children}
	</Nav.Item>
);

const NavItemBody = ({
	linkProps,
	target,
	classNames,
	icon,
	image,
	route,
	badgeText,
	badgeBg,
	badgeColor,
}) => (
	<Nav.Link {...linkProps} target={target} className={classNames}>
		<span>
			{icon ? (
				<span className="sidebar-icon">
					<FontAwesomeIcon icon={icon} />{" "}
				</span>
			) : null}
			{image ? (
				<Image
					src={image}
					width={20}
					height={20}
					className="sidebar-icon svg-icon"
				/>
			) : null}
			<span className="sidebar-text">{route.title}</span>
		</span>
		{badgeText ? (
			<Badge
				pill
				bg={badgeBg}
				text={badgeColor}
				className="badge-md notification-count ms-2"
			>
				{badgeText}
			</Badge>
		) : null}
	</Nav.Link>
);

export const SideNavItem = ({
	route,
	external,
	target,
	icon,
	image,
	setShow = () => {},
	badgeText,
	badgeBg = "secondary",
	badgeColor = "primary",
	variant = "",
}) => {
	const { route: selectedRoute } = useContext(RouteContext);
	const { selectedSite } = useContext(SiteContext);
	const { selectedOrgId } = useContext(UserDataContext);
	const link = route.path;
	let classNames = badgeText
		? `d-flex justify-content-start align-items-center justify-content-between`
		: "";

	classNames += ` ${variant === "bold" ? "fw-bold" : ""}`;

	let navItemClassName =
		(route === selectedRoute ||
			(selectedRoute.breadcrumbs &&
				selectedRoute.breadcrumbs[0].path === route.path)) &&
		!external
			? "active"
			: "";

	if (route === blastRoutes.presentation && selectedRoute.isSitePage)
		navItemClassName = "active";

	// Link straight to the fully org-scoped path. The route table also matches
	// the bare paths (e.g. "/sites"), but landing on a bare path leaves
	// ChangeOrg with no :orgId param, so it bounces to the "/org/:orgId/..."
	// form via <Navigate>. Under react-router v7 that <Navigate> performs the
	// redirect in a useEffect, so it first renders null — the whole layout
	// unmounts and the bare #root paints for one frame, a white flash on every
	// navigation (v5's <Redirect> redirected during render, so it never did
	// this). Building the org-scoped URL up front skips the redirect entirely.
	// Fall back to the bare path if we don't have an org yet.
	const orgPrefix = selectedOrgId ? `/org/${selectedOrgId}` : "";
	const linkProps = external
		? { href: link + "org/" + selectedOrgId }
		: {
				as: Link,
				to: route.isSitePage
					? `${orgPrefix}/site/${selectedSite.id}${link}`
					: `${orgPrefix}${link}`,
		  };

	return (
		<>
			<ToggleWrapper
				navItemClassName={navItemClassName}
				setShow={setShow}
			>
				<NavItemBody
					{...{
						linkProps,
						target,
						classNames,
						icon,
						image,
						route,
						badgeText,
						badgeBg,
						badgeColor,
					}}
				/>
			</ToggleWrapper>
			<ToggleWrapper navItemClassName={navItemClassName}>
				<NavItemBody
					{...{
						linkProps,
						target,
						classNames,
						icon,
						image,
						route,
						badgeText,
						badgeBg,
						badgeColor,
					}}
				/>
			</ToggleWrapper>
		</>
	);
};
